/* import __COLOCATED_TEMPLATE__ from './ach-account-list.hbs'; */
import Component from '@glimmer/component';
import styles from './ach-account-list.module.scss';

export default class SiteBillingAchAccountList extends Component {
  styles = styles;

  get accounts() {
    return this.args.accounts || [];
  }
}
